import React from 'react';
import { Link } from 'react-router-dom';

const Portfolio = () => {
    return (
        <>
            <div className="my-4 py-4" id='portfolio'>
                <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">Geljekde ornaşdyryljak goşmaça hyzmatlar</h2>
                <div className='flex justify-center'>
                    <div className='w-24 border-b-4 border-blue-900 mb-8'></div>
                </div>

                <div className="px-4" data-aos="fade-down" data-aos-delay="600">
                    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">                            
                        <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3 min-h-max">
                            <div className="m-2 text-justify text-sm">
                                <h4 className="font-semibold my-4 text-lg md:text-2xl text-center mb-4 h-12">Mebel öndürmek we gurnamak</h4>
                                <p className="text-md font-medium leading-5 h-auto md:h-48">
                                    Ykbal H.J. geljekde müşderilerimize mebel öndürmek we gurnamak hyzmatlaryny hem hödürlär. Bu täze ugur ýokary hilli materiallardan öndürilen, ergonomiki we bezeg taýdan döwrebap mebelleri öz içine alar.
Her bir mebel görnüşi (ýaşaýyş, ofis, jemgyýetçilik ýerleri üçin) aýratyn taslamanyň esasynda taýýarlanyp, içki giňişligiň estetikasyna laýyk getirer.
Şeýle hem mebeliň gurnalmagy, ýerleşdirilmegi we tehniki hyzmaty doly integrirlenen hyzmat hökmünde hödürlener. Bu hyzmat, müşderilere amatly we “bir nokatdan” çözgüt bermek maksady bilen ýola goýlar.
</p>
                                <div className="flex justify-center my-4">
                                </div>
                            </div>
                        </div>

                        <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3">
                            <div className="m-2 text-justify text-sm">
                                <h4 className="font-semibold my-4 text-lg md:text-2xl text-center mb-4 h-12">Howpsuzlyk ulgamlaryny ornaşdyrmak</h4>
                                <p className="text-md font-medium leading-5 h-auto md:h-48">
                                     Biziň meýilnamamyza laýyklykda, ýakyn geljekde ýokary tehnologiýaly howpsuzlyk ulgamlaryny ornaşdyrmak hyzmaty işe giriziler.
Bu ugurda müşderilere wideonazorat ulgamlary, hereket duýduryş enjamlary, giriş dolandyryş ulgamlary hem-de umumy howpsuzlyk strategiýalaryny düzmek hyzmatlary hödürlener.
Hyzmatyň çäginde dizaýn, enjamlaryň saýlanyp alnmagy, professional gurmak we tehniki hyzmat bilen doly paket üpjün ediler.
Bu täze mümkinçilik bina gurluşygy bilen utgaşykly alnyp barylyp, ähli ulgamlaryň bir bitewi ulgam hökmünde işlemegini üpjün eder.

</p>
                                <div className="flex justify-center my-4">
                                </div>
                            </div>
                        </div>

                        <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3">
                            <div className="m-2 text-justify text-sm">
                            <h4 className="font-semibold my-4 text-lg md:text-2xl text-center mb-4 h-12">Energiýa tygşytlaýjy çözgütler</h4>
                                <p className="text-md font-medium leading-5 h-auto md:h-48">
                                  Daşky gurşawy goramak we energiýa çykdajylaryny azaltmak maksady bilen, energiýa tygşytlaýjy çözgütler boýunça ýörite hyzmatlaryň işe girizilmegi meýilleşdirilýär.
Bu hyzmatlar gün panelleriniň ornaşdyrylmagyny, ýylylyk izolýasiýasynyň gurnalmagyny we akylly yşyklandyryş ulgamlarynyň düzülmegini öz içine alar.
Şeýlelikde, müşderiler diňe bir gurluşyk däl, eýsem energiýa netijeliligi boýunça hem doly çözgüt alarlar.
Ulgamlar halkara standartlaryna laýyklykda işlenip düzülip, gysga we uzak möhletleýin ykdysady peýdalary üpjün eder.
</p>
                                <div className="flex justify-center my-4">
                                </div>
                            </div>
                        </div>

                        <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3">
                            <div className="m-2 text-justify text-sm">
                                <h4 className="font-semibold my-4 text-lg md:text-2xl text-center mb-4 h-12">Ýer içi infrastruktura hyzmatlary</h4>
                                <p className="text-md font-medium leading-5 h-auto md:h-48">
                                Ykbal H.J. gurluşykdan başga-da, ýer içi inženerçilik ulgamlaryny çekmek boýunça hyzmatlary ösdürmegi maksat edinýär.
Bu hyzmatlaryň çäginde suw geçiriji turbalary, kanalizasiýa ulgamlaryny, elektrik we internet liniýalaryny çekmek işleri ýerine ýetiriler.
Her bir çözgüt gurluşyk taslamasynyň aýratynlygyna görä tehniki taýdan hasaplanar we iň ýokary hil talaplaryna laýyk ornaşdyrylar.
Bu täze ugur gurluşygyň ähli tapgyrlarynda bir bitewi hyzmat döretmek üçin möhüm ädim bolar.
</p>
                                <div className="flex justify-center my-4">
                                    {/*<Link to="/get-demo" className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-xl">
                                        Schedule Demo
                                        <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                    </Link>*/}
                                </div>
                            </div>
                        </div>                    
                    </div>
                </div>
            </div>
        </>
    )
}

export default Portfolio;